<template>
  <div
    v-if="state"
    class="san-sortby"
  >
    <slot
      :items="state.options"
      :has-no-results="state.hasNoResults"
      :refine="state.refine"
      :current-refinement="state.currentRefinement"
      :can-refine="state.canRefine"
    >
      <SanFieldSelect
        v-model="selected"
        class="san-sortby--select"
        aria-label="Sort results by"
        name="sort-by"
        :options="options"
        :initial-value="options[0].label"
        dense
        hide-bottom-space
        @update:model-value="onRefine"
      >
        <template
          v-if="selected !== options[0].value"
          #after
        >
          <Button
            size="md"
            :icon="`mono-order-by-${currentOrder}`"
            variant="text"
            color="secondary"
            is-icon
            @click="onOrder"
          >
            <Tooltip position="bottom">
              {{ t(`SortBy.order.${currentOrder}.tooltip`) }}
            </Tooltip>
          </Button>
        </template>
      </SanFieldSelect>
    </slot>
  </div>
</template>

<script setup>
import { inject, ref, computed, watch } from 'vue'
import { useConnector } from '@/composables'
import { connectSortBy } from 'instantsearch.js/es/connectors'
import { useTranslation } from 'i18next-vue'

defineOptions({ name: 'SortBy' })
const props = defineProps({
  indexName: { type: String, required: true },
  options: { type: Array, required: true },
  transformItems: { type: Function, default: undefined }
})

const $emitter = inject('instantSearchPanelEmitter', { emit: () => {} })

const { t } = useTranslation('instantsearch')

const selected = ref(null)
const hasEmitted = ref(false)
const currentOrder = ref('asc')

const options = computed(() => props.options.map((o, i) => {
  const label = o.label
  const value = i === 0 ? props.indexName : `${props.indexName}/sort/${o.value}:${currentOrder.value}`
  // const value = i === 0 ? `${props.indexName}/sort/_text_match:${currentOrder.value}` : `${props.indexName}/sort/${o.value}:${currentOrder.value}`
  return { label, value }
}))

const transformItems = items => {
  items.forEach(item => {
    // print out all the selected facets when a facet is clicked
    if (item.isRefined) {
      console.log('this item is selected:')
      console.log(item)
    }
  })

  return props.transformItems ? props.transformItems(items) : items
}

const state = useConnector(connectSortBy, {
  $$widgetType: 'ais.sortBy',
  items: options.value,
  transformItems
})

const mapStateToCanRefine = s => !!s.canRefine

const onRefine = val => state.value.refine(val)

const onOrder = () => {
  currentOrder.value = currentOrder.value === 'asc' ? 'desc' : 'asc'
  const value = selected.value.replace(/(:)(asc|desc)$/, `:${currentOrder.value}`)
  onRefine(value)
  // const value = selected.value.split(':')
  // if (value[1]) value[1] = currentOrder.value
  // console.log(value.join(':'))
  // onRefine(value.join(':'))
}

watch(() => state.value, (newState, oldState) => {
  if (!newState) return

  selected.value = newState.currentRefinement

  const previousCanRefine = mapStateToCanRefine(oldState || {})
  const nextCanRefine = mapStateToCanRefine(newState)

  if (!hasEmitted.value || previousCanRefine !== nextCanRefine) {
    $emitter.emit('PANEL_CHANGE_EVENT', nextCanRefine)
    hasEmitted.value = true
  }
}, { immediate: true })
</script>
